import webIcon from '../../assets/images/icons/web.png';
import gameIcon from '../../assets/images/icons/gameDev.png';
import designIcon from '../../assets/images/icons/design.png';

export const SKILLS = [
	{ name: 'Full Stack', icon: webIcon },
	{ name: 'AI/ML', icon: gameIcon },
	{ name: 'Tools', icon: designIcon },
];
